// extracted by mini-css-extract-plugin
module.exports = {"collapse":"_2_UdZkqgm_67kEyiCCboTF","markAndNumbers":"_2v36uG_aSdhtSkxAk1WFAB","contactInfo":"_1r58NIXdRhPbLW-f3dQyrk"};